//singleton instance
import { io, Socket } from "socket.io-client";

let socketInstance: Socket | null = null;

export const getSocket = (): Socket => {
  if (socketInstance?.connected) {
    // console.log("♻️ Reusing existing connected socket:", socketInstance.id);
    return socketInstance;
  }

  if (socketInstance) {
    console.log("♻️ Socket exists but not connected, reusing:", socketInstance);
    return socketInstance;
  }

  console.log("🔌 Creating NEW socket connection...");
  // const token = Cookies.get("client-token");

  socketInstance = io(import.meta.env.VITE_SOCKET_CONNECT_API_URL, {
    withCredentials: true,
    autoConnect: true,
    query: {
      requestOrigin: "admin",
    },
    auth: {
      token: "",
    },
    // Infinite reconnection
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    randomizationFactor: 0.5,
    timeout: 20000,
    path: "/ws",
    transports: ["websocket", "polling"],
  });

  // Event handlers - set up only once
  // socketInstance.on("connect", () => {
  //   console.log("✅ Socket connected:", socketInstance?.id);
  // });

  // socketInstance.on("disconnect", (reason) => {
  //   console.log("⚠️ Socket disconnected:", reason);

  //   // Manual reconnect if server forcefully dissconnected
  //   if (reason === "io server disconnect") {
  //     socketInstance?.connect();
  //   }
  // });

  socketInstance.on("connect_error", (error) => {
    console.error("❌ Connection error:", error.message);
  });

  socketInstance.on("reconnect_attempt", (attemptNumber) => {
    console.log(`🔄 Reconnection attempt #${attemptNumber}`);
  });

  // socketInstance.on("server-ready", (message) => {
  //   console.log(`📨 Message from server: ${message}`);
  // });

  return socketInstance;
};

export const destroySocket = () => {
  if (socketInstance) {
    console.log("🔴 Disconnecting and DESTROYING socket:", socketInstance.id);
    socketInstance.removeAllListeners();
    socketInstance.close();
    socketInstance = null;
  } else {
    console.log("ℹ️ No socket to disconnect");
  }
};
